/* eslint-disable react/react-in-jsx-scope */
import { popup } from "venuescanner-js/vanilla/components/popup";
import { $ } from "venuescanner-js/tools/elemental";
// eslint-disable-next-line no-unused-vars
import { node, jsxWatch } from "venuescanner-js/tools/jsx";
import service from "./service";
import { Library } from "./Library";
import { BOOLEAN } from "venuescanner-js/vanilla/models/ObservablePropTypes";

import("./attachments.scss");

const data = {
  venue: null,
  library: null,
};
const LibraryContainer = ({ showVenueLibrary, onAttach, isMobileDevice }) => {
  jsxWatch("watch=(showVenueLibrary)");
  if (data.library) {
    return (
      <Library
        library={data.library}
        whenAttached={(arr) => {
          onAttach(arr);
          popup.close();
        }}
        isMobileDevice={isMobileDevice}
      />
    );
  }
};
const LibraryButtons = ({ showVenueLibrary, onToggle }) => {
  jsxWatch("watch=(showVenueLibrary)");
  return (
    <div>
      <vs-btn
        type="asLink"
        disabled={showVenueLibrary.valueOf()}
        onClick={onToggle}
      >
        venue
      </vs-btn>{" "}
      /{" "}
      <vs-btn
        type="asLink"
        onClick={onToggle}
        disabled={!showVenueLibrary.valueOf()}
      >
        your
      </vs-btn>
    </div>
  );
};
const LibrarySelector = ({ onAttach, isMobileDevice }) => {
  const showVenueLibrary = new BOOLEAN(null, !!data.venue);
  const onToggle = () => {
    service
      .fetch(showVenueLibrary.valueOf() ? undefined : data.venue)
      .then((response) => {
        data.library = response;
        showVenueLibrary.toggle();
      });
  };
  return (
    <div class="attachment-container">
      {!!data.venue && (
        <LibraryButtons
          showVenueLibrary={showVenueLibrary}
          onToggle={onToggle}
        />
      )}
      <LibraryContainer
        showVenueLibrary={showVenueLibrary}
        library={data.library}
        onAttach={onAttach}
        isMobileDevice={isMobileDevice}
      />
    </div>
  );
};
export default {
  open: ({ venue, onAttach = () => {}, isMobileDevice }) => {
    popup.new(<div class="centered">Loading the library&hellip;</div>, {
      loading: true,
      fullscreen: isMobileDevice,
    });
    service
      .fetch(venue)
      .then((response) => {
        data.venue = venue;
        data.library = response;
        popup.show(
          <LibrarySelector
            onAttach={onAttach}
            isMobileDevice={isMobileDevice}
          />,
          { closable: true }
        );
      })
      .catch(() => {
        popup.show(<div class="centered">Failed to load your library</div>, {
          success: false,
          closable: true,
        });
      });
  },
};
